import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useParams } from 'react-router-dom';
export var useSelectorProps = function useSelectorProps() {
  var location = useLocation();
  var params = useParams();
  var intl = useIntl();
  var selectorProps = useMemo(function () {
    return {
      location: location,
      params: params,
      intl: intl
    };
  }, [location, params, intl]);
  return selectorProps;
};
export default useSelectorProps;